<template lang="html">
   <div class="s-top-nav clearfix">
      <div class="left">
         <div class="header">
            <div class="navTrigger" @click="toggleNav()">
               <i></i><i></i><i></i>
            </div>
         </div>
      </div>
      <div class="right">
         <Dropdown 
            class="dropdown fx-dropdown"
            trigger="click"
            placement="left-start"
            v-if="user && user.names"
         >
            <div class="fx-nav-item dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
               <div class="avatar-box" data-toggle="tooltip" title="Profile">{{initials}}</div>
            </div>

            <DropdownMenu slot="list" class="profile">
               <div class="profile-details">
                  <div class="center">
                     <div class="avatar-box" data-toggle="tooltip" title="Profile">{{initials}}</div>
                  </div>
                  <div class="prof-title">{{`${user.names}`}}</div>
                  <div class="subtitle" v-if="user.userType">{{}}</div>
               </div>

               
               <!-- <DropdownItem>
                  <div class="action clearfix" @click="clickAction('project')">
                     <div class="fa fa-project-diagram"></div>
                     <div class="title">Change Project</div>
                  </div>
               </DropdownItem>
               <DropdownItem>
                  <div class="action clearfix" @click="clickAction('password')">
                     <div class="fa fa-life-ring"></div>
                     <div class="title">Change Password</div>
                  </div>
               </DropdownItem>
               <DropdownItem>
                  <div class="action clearfix" @click="clickAction('settings')">
                     <div class="fa fa-cog"></div>
                     <div class="title">Account Settings</div>
                  </div>
               </DropdownItem> -->
               <DropdownItem>
                  <div class="action clearfix" @click="logOut($router)">
                     <div class="fa fa-power-off"></div>
                     <div class="title">{{main_lang.sign_out}}</div>
                  </div>
               </DropdownItem>
            </DropdownMenu>
         </Dropdown>
      </div>
   </div>
</template>

<script>
export default {
   components:{
      Dropdown: () => import("clarks/components/dropdown/dropdown"),
      DropdownItem: () => import("clarks/components/dropdown/dropdown-item"),
      DropdownMenu: () => import("clarks/components/dropdown/dropdown-menu"),
   },
   computed: {
      ...mapGetters([
         'loading',
         'initials',
      ])
   },
   data () {
      return {
         main_lang,
         user: {},
      }
   },
   methods: {
      ...mapActions([
         'logOut',
         'generateInitials',
         // 'resetPassword',
         // 'clickAction',
         // 'submitUpdate',
         // 'fetchFormData',
      ]),
      toggleNav () {
         this.$el.querySelector('.navTrigger').classList.toggle('active')
         document.querySelector('.nav-side').classList.toggle('show-mobile')
      },
   },
   async mounted(){
      this.user = await $session.get('user')
      if(this.user && this.user.names){
         await this.generateInitials(this.user.names)
      }
   }
}
</script>

<style lang="scss">
   .s-top-nav{
      .profile {
         width: 230px;

         .profile-details {
            padding   : 10px 20px;
            text-align: center;
            margin    : 0 0 10px 0;

            .center{
               display: flex;
               justify-content: center;
            }
            
            .avatar-box{
               width        : 40px;
               height       : 40px;
               border-radius: 50%;
               background: $primary;
               color: $white;
               font-size: 20px;
               text-align: center;
               font-weight: 600;
               padding: 5px 0;
            }

            .prof-title {
               font-size     : 12px;
               text-transform: uppercase !important;
               padding       : 10px 0 0 0;
               font-weight   : 600;
            }

            .subtitle {
               color    : $text-grey;
               font-size: 12px;
            }
         }

         .ivu-dropdown-item{
            padding : 1px 10px 1px 10px !important;
         }
         .action {
            padding: 3px 10px;
            cursor : pointer;

            .fa {
               float  : left;
               padding: 2px 0 0 0;
            }

            .title {
               float  : left;
               padding: 1px 5px 5px 15px !important;
            }
         }
      }
   }
</style>